import template from './about-house.jade';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      category: '@',
      categoryInfo: '=',
      ad: '=',
      form: '=',
    },
    controller() {},
    controllerAs: 'aboutHouseCtrl',
    replace: true,
  };
};
